export default "__VITE_ASSET__DcbXmAx3__"